import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import {
  ChangeDistanceAsAdminBody,
  ChangeDistanceAsAdminRes,
  RegisterUserAsAdminBody,
  RegisterUserAsAdminResponse,
  PostApplicationsBody,
  PostApplicationsResponse,
  PostApplicationsPwdBody,
  PostApplicationsPwdResponse,
  PostApplicationsMoneyBody,
  PostApplicationsMoneyResponse,
  PostApplicationsInsuranceBody,
  PostApplicationsInsuranceResponse,
  PostApplicationsInsurancePromocodeBody,
  PostApplicationsInsurancePromocodeResponse,
  PostApplicationsInsurancePwdBody,
  PostApplicationsInsurancePwdResponse,
  PostApplicationsChangeDistanceBody,
  PostApplicationsChangeDistanceResponse,
  PostApplicationsMarathonMarkParams,
  PostApplicationsMarathonUnmarkResponse,
  PostApplicationsMarathonUnmarkParams,
  GetApplicationsByIdParams,
  GetApplicationsByIdResponse,
  GetApplicationsMarathonIndividualIssuanceParams,
  GetApplicationsMarathonIndividualIssuanceResponse,
  GetApplicationsMarathonCorporateIssuanceParams,
  GetApplicationsMarathonCorporateIssuanceResponse,
  GetApplicationsMarathonsExcelParams,
  GetMyApplicationsParams,
  GetMyApplicationsResponse,
  GetApplicationsMarathonPublicParams,
  GetApplicationsMarathonPublicResponse,
  PutApplicationsMarathonExcelParams,
  RegisterUserBody,
  RegisterUserResponse,
  DeleteApplicationByIdResponse,
  DeleteApplicationByIdParams,
} from "./types";

export const ApplicationsAPI = {
  registerUserAsAdmin: async (
    body: RegisterUserAsAdminBody
  ): Promise<RegisterUserAsAdminResponse> => {
    const response = await axiosApi.post<RegisterUserAsAdminResponse>(
      `applications/registerUserAsAdmin`,
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  registerUser: async (
    body: RegisterUserBody
  ): Promise<RegisterUserResponse> => {
    const response = await axiosApi.post<RegisterUserResponse>(
      `applications/register`,
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  changeDistanceAsAdmin: async (
    body: ChangeDistanceAsAdminBody
  ): Promise<ChangeDistanceAsAdminRes> => {
    const response = await axiosApi.post<ChangeDistanceAsAdminRes>(
      `applications/changeDistanceAsAdmin`,
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postApplications: async (
    body: PostApplicationsBody
  ): Promise<PostApplicationsResponse> => {
    const response = await axiosApi.post<PostApplicationsResponse>(
      "/applications",
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postApplicationsPwd: async (
    body: PostApplicationsPwdBody
  ): Promise<PostApplicationsPwdResponse> => {
    const response = await axiosApi.post<PostApplicationsPwdResponse>(
      "/applications/pwd",
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postApplicationsMoney: async (
    body: PostApplicationsMoneyBody
  ): Promise<PostApplicationsMoneyResponse> => {
    const response = await axiosApi.post<PostApplicationsMoneyResponse>(
      "/applications/money",
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postApplicationsInsurance: async (
    body: PostApplicationsInsuranceBody
  ): Promise<PostApplicationsInsuranceResponse> => {
    const response = await axiosApi.post<PostApplicationsInsuranceResponse>(
      "/applications/insurance",
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postApplicationsInsurancePromocode: async (
    body: PostApplicationsInsurancePromocodeBody
  ): Promise<PostApplicationsInsurancePromocodeResponse> => {
    const response =
      await axiosApi.post<PostApplicationsInsurancePromocodeResponse>(
        "/applications/insurance-promocode",
        body,
        {
          headers: {
            "Accept-Language": checkCurrentLanguage(),
          },
        }
      );
    return response.data;
  },
  postApplicationsInsurancePwd: async (
    body: PostApplicationsInsurancePwdBody
  ): Promise<PostApplicationsInsurancePwdResponse> => {
    const response = await axiosApi.post<PostApplicationsInsurancePwdResponse>(
      "/applications/insurance-pwd",
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postApplicationsChangeDistance: async (
    body: PostApplicationsChangeDistanceBody
  ): Promise<PostApplicationsChangeDistanceResponse> => {
    const response =
      await axiosApi.post<PostApplicationsChangeDistanceResponse>(
        "/applications/change-distance",
        body,
        {
          headers: {
            "Accept-Language": checkCurrentLanguage(),
          },
        }
      );
    return response.data;
  },
  postApplicationsMarathonMark: async ({
    marathonId,
    ...params
  }: PostApplicationsMarathonMarkParams): Promise<void> => {
    const response = await axiosApi.post<void>(
      `/applications/marathon/${marathonId}/mark`,
      params,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postApplicationsMarathonUnmark: async ({
    marathonId,
    ...params
  }: PostApplicationsMarathonUnmarkParams): Promise<PostApplicationsMarathonUnmarkResponse> => {
    const response =
      await axiosApi.post<PostApplicationsMarathonUnmarkResponse>(
        `/applications/marathon/${marathonId}/unmark`,
        params,
        {
          headers: {
            "Accept-Language": checkCurrentLanguage(),
          },
        }
      );
    return response.data;
  },
  getApplicationsById: async ({
    applicationId,
    ...params
  }: GetApplicationsByIdParams): Promise<GetApplicationsByIdResponse> => {
    const response = await axiosApi.get<GetApplicationsByIdResponse>(
      `/applications/${applicationId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  deleteApplicationById: async ({
    applicationId,
    ...params
  }: DeleteApplicationByIdParams): Promise<DeleteApplicationByIdResponse> => {
    const response = await axiosApi.delete<DeleteApplicationByIdResponse>(
      `/applications/${applicationId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getApplicationsMarathonIndividualIssuance: async ({
    marathonId,
    ...params
  }: GetApplicationsMarathonIndividualIssuanceParams): Promise<GetApplicationsMarathonIndividualIssuanceResponse> => {
    const response =
      await axiosApi.get<GetApplicationsMarathonIndividualIssuanceResponse>(
        `/applications/marathon/${marathonId}/individualIssuance`,
        {
          params,
          headers: {
            "Accept-Language": checkCurrentLanguage(),
          },
        }
      );
    return response.data;
  },
  getApplicationsMarathonCorporateIssuance: async ({
    marathonId,
    corporateClientId,
    ...params
  }: GetApplicationsMarathonCorporateIssuanceParams): Promise<GetApplicationsMarathonCorporateIssuanceResponse> => {
    const response =
      await axiosApi.get<GetApplicationsMarathonCorporateIssuanceResponse>(
        `/application/marathons/${marathonId}/corporateIssuance/${corporateClientId}`,
        {
          params,
          headers: {
            "Accept-Language": checkCurrentLanguage(),
          },
        }
      );
    return response.data;
  },
  getApplicationsMarathonsExcel: async ({
    marathonId,
    ...params
  }: GetApplicationsMarathonsExcelParams): Promise<void> => {
    const response = await axiosApi.get<void>(
      `/applications/marathons/${marathonId}/excel`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getMyApplications: async (
    params: GetMyApplicationsParams
  ): Promise<GetMyApplicationsResponse> => {
    const response = await axiosApi.get<GetMyApplicationsResponse>(
      "/applications/myApplications",
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getApplicationsMarathonPublic: async ({
    marathonId,
    ...params
  }: GetApplicationsMarathonPublicParams): Promise<GetApplicationsMarathonPublicResponse> => {
    const response = await axiosApi.get<GetApplicationsMarathonPublicResponse>(
      `/applications/marathon-public/${marathonId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  putApplicationsMarathonExcel: async ({
    marathonId,
    ...params
  }: PutApplicationsMarathonExcelParams): Promise<void> => {
    await axiosApi.put<void>(
      `/applications/marathon/${marathonId}/excel`,
      params,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
  },
};
